<template  xmlns:v-bind="http://www.w3.org/1999/xhtml">
  <div class="app">
    <div id="geoPage" style="display: none"></div>
    <div class="mask transparent" v-if="isLoading">
      <div class="loading"><p>正在定位中...</p></div>
    </div>
  </div>
</template>
<script>
import wechatService from 'wechat.service'
import wx from 'jweixin-1.4.0'
import utils from 'utils'

/* eslint-disable */
export default {
  mounted () {

  },
  created () {
    // this.isLoading = true
    // this.getTargetPoint();
  },
  data: function () {
    return {
      toPageName: this.$store.state.paramModule.param.getLocation.url,
      isLoading: false,
      // 当前位置坐标
      localPoint: {
        latitude: '',
        longitude: ''
      },
      // 目的地位置坐标
      targetPoint: {
        latitude: '',
        longitude: ''
      },
      // 微信API配置相关
      wechatConfig: {}
    }
  },
  methods: {
    // 获取当前位置
    // getLocationPoint () {
      // if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      //   //ios系统，调用百度地图定位
      //   this.getBaiduCurrentLocationPoint()
      // } else {
      //   //安卓和Pc  调用腾讯定位
      //   this.getWxConfigParams();
      // }
      // this.getWxConfigParams();
    // },
    // getTargetPoint () {
    //   // 拿到院区地址
    //   const address = JSON.parse(localStorage.selectedArea).areaAddr
    //   // 创建地址解析器实例
    //   let myGeo = new BMap.Geocoder();
    //   let that = this
    //   myGeo.getPoint(address, function (point) {
    //     if (!point) {
    //       utils.alert("您选择的地址没有解析到结果!");
    //       return
    //     }
    //     that.targetPoint.latitude = point.lat
    //     that.targetPoint.longitude = point.lng
    //     localStorage.setItem('targetPoint', JSON.stringify(that.targetPoint))
    //     that.getLocationPoint()
    //   }, "彭州市");
    // },
    /**
     * 获取初始化微信API所需的参数(微信appId，签名等)
     */
    // getWxConfigParams () {
    //   // 调用后台接口获取微信API所需要的appId等参数
    //   wechatService.getWechatConfig({
    //     url: location.href.split("#")[0],
    //     orgId: http.headers.common['organizationId'],
    //   }).then((res) => {
    //     if (res.resultCode !== this.constant.RESULT_SUCCESS) {
    //       utils.alert('获取初始化微信API所需的参数失败： ' + res.resultMsg)
    //       return
    //     }
    //     this.wechatConfig = res.data
    //     this.initWxAPI()
    //   })
    // },

    /**
     * 初始化微信API
     */
    // initWxAPI () {
    //   if (typeof (wx) === 'undefined') {
    //     console.log('由于微信版本兼容性问题，无法使用微信API')
    //     return
    //   }
    //   wx.config({
    //     debug: false,
    //     appId: this.wechatConfig.appId, // 必填，公众号的唯一标识
    //     timestamp: this.wechatConfig.timestamp, // 必填，生成签名的时间戳
    //     nonceStr: this.wechatConfig.nonceStr, // 必填，生成签名的随机串
    //     signature: this.wechatConfig.signature, // 必填，微信签名
    //     jsApiList: ['getLocation'],// 必填，需要使用的JS接口列表
    //   })
    //   wx.ready(() => {
    //     // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
    //     this.getWxLocation()
    //   });
    //   wx.error(() => {
    //     // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
    //     utils.alert('微信API注册失败')
    //     this.goToNextModule()
    //   });
    // },

    /**
     * 获取微信API提供的当前位置坐标
     */
    // getWxLocation () {
    //   let that = this
    //   wx.getLocation({
    //     type: 'wgs84', // 默认为wgs84的gps坐标，如果要返回直接给openLocation用的火星坐标，可传入'gcj02'
    //     success: function (res) {
    //       that.changeToBaiduPoint(res)
    //     }
    //   });
    // },

    /**
     * 将微信API提供的当前位置坐标转化为百度地图能识别的坐标
     */
    // changeToBaiduPoint (wxPoint) {
    //   const url = 'http://api.map.baidu.com/geoconv/v1/'
    //   const lat = wxPoint.latitude
    //   const lng = wxPoint.longitude
    //   const point = lng + ',' + lat
    //   const wxPointParams = {
    //     coords: point,
    //     from: '1',
    //     to: '5',
    //     ak: 'arhAOpUaq5SzqOLMYDMk85ot4D67iLes',
    //   }
    //   let that = this
    //   $.ajax(url, {
    //     data: wxPointParams,
    //     dataType: 'jsonp',
    //     crossDomain: true,
    //     success: function (data) {
    //       if (data && data.status === 0) {
    //         that.localPoint.latitude = data.result[0].y
    //         that.localPoint.longitude = data.result[0].x
    //         localStorage.setItem('locationPoint', JSON.stringify(that.localPoint))
    //       }
    //       that.goToNextModule()
    //     }
    //   })
    // },

    // 直接使用百度地图API获取当前位置坐标经纬度
    // getBaiduCurrentLocationPoint () {
    //   let map = new BMap.Map("geoPage");
    //   let point = new BMap.Point(112.93373161865233, 28.303075996747943);
    //   map.centerAndZoom(point, 12);
    //   let geo = new BMap.Geolocation();
    //   let that = this
    //   geo.getCurrentPosition(function (r) {
    //     if (this.getStatus() == BMAP_STATUS_SUCCESS) {
    //       let mk = new BMap.Marker(r.point);
    //       map.addOverlay(mk);
    //       map.panTo(r.point);
    //       localStorage.setItem('locationPoint', JSON.stringify(r))
    //     }
    //     that.goToNextModule()
    //   }, { enableHighAccuracy: true })
    // },

    /* 跳转至对应页面 */
    goToNextModule () {
      this.isLoading = false
      this.$router.replace(this.toPageName)
    },
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// GetLocation.vue?acff6a32